export default __webpack_public_path__ + "src/images/packages/saseka-tented-camp/6c108b40d4fd9c9bf582965e3db2390f-1.jpg";